import { KEYS } from "@/src/const";

function localeDirection(locale: string): "rtl" | "ltr" {
  switch (locale ?? "en") {
    case "ar":
      return "rtl";
    default:
      return "ltr";
  }
}

function setLocaleToLocalStorage(locale: string) {
  localStorage.setItem(KEYS.LOCALE, locale);
}

function getLocaleToLocalStorage() {
  return localStorage.getItem(KEYS.LOCALE);
}

export default {
  localeDirection,
  setLocaleToLocalStorage,
  getLocaleToLocalStorage,
};
